import { j as s, c as w } from "./utils-BdNIfrGQ.js";
import { L as H } from "./Label-kWLyCHVQ.js";
import N, { useRef as y, useCallback as R, useLayoutEffect as z } from "react";
import { I as V } from "./BaseInput.styles-Bn99zfPn.js";
import { c as b } from "./index-Di82Y7n3.js";
import { D as L } from "./Div-spVpsZsH.js";
import "./Div.skeleton-DLnqOZrU.js";
import { F as M } from "./Flex-BA9xHq_p.js";
import "./Grid-DJGISvmf.js";
const B = b(
  "pl-5 pr-4 w-full items-center rounded-[8px] bg-white focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border border-gray-400 min-h-[40px] gap-0",
        cta: "rounded-r-[32px] border border-gray-100 shadow min-h-[40px] pr-0"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), U = b("", {
  variants: {
    variant: {
      default: "",
      cta: "[&>button]:py-4"
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), W = b("", {
  variants: {
    variant: {
      default: "hidden",
      cta: "block"
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), X = {
  default: { variant: "ghost", size: "icon" },
  cta: { variant: "outline", size: "sm" }
}, T = 6, I = (m) => {
  const { element: t, minRows: a, maxRows: f = T } = m;
  t.style.height = "auto";
  const n = window.getComputedStyle(t), l = Number.parseFloat(n.lineHeight) || 24, r = Number.parseFloat(n.paddingTop) || 0, c = Number.parseFloat(n.paddingBottom) || 0, h = l * a + r + c, u = l * Math.max(f, a) + r + c, o = Math.min(Math.max(t.scrollHeight, h), u);
  return t.style.height = `${o}px`, t.style.overflowY = t.scrollHeight > u ? "auto" : "hidden", o;
}, _ = N.forwardRef(
  (m, t) => {
    const {
      label: a,
      helperText: f,
      error: n,
      spacing: l,
      hideLabel: r = !1,
      action: c,
      onChange: h,
      rows: u,
      maxRows: o = T,
      expandable: d = !0,
      ...p
    } = m, v = y(null), g = y(null), x = u ?? 2, i = R(
      (e) => {
        if (e && d) {
          const F = I({ element: e, minRows: x, maxRows: o });
          g.current && (g.current.style.height = `${F}px`);
        }
      },
      [d, o, x]
    ), C = R(
      (e) => {
        v.current = e, typeof t == "function" ? t(e) : t && (t.current = e), i(e);
      },
      [i, t]
    );
    z(() => {
      i(v.current);
    }, [i, p.value]);
    const j = (e) => {
      h?.(e), i(e.currentTarget);
    };
    return /* @__PURE__ */ s.jsxs(V, { spacing: l, size: "full", children: [
      /* @__PURE__ */ s.jsx(
        H,
        {
          htmlFor: p.id,
          helperText: f,
          required: p.required,
          variant: r ? "hidden" : "visible",
          children: a
        }
      ),
      /* @__PURE__ */ s.jsxs(M, { className: w(B(), "items-end py-4"), gap: "4", children: [
        /* @__PURE__ */ s.jsx(
          L,
          {
            ref: g,
            className: w(
              "min-w-0 flex-1",
              d && "overflow-hidden transition-[height] duration-150 ease-out motion-reduce:transition-none"
            ),
            children: /* @__PURE__ */ s.jsx(
              "textarea",
              {
                className: w(
                  "block border-none appearance-none outline-none bg-transparent w-full min-w-0 resize-none focus:outline-none focus:ring-0",
                  !d && "overflow-y-auto"
                ),
                ref: C,
                rows: x,
                "aria-label": r ? a : void 0,
                ...p,
                onChange: j
              }
            )
          }
        ),
        c
      ] }),
      n
    ] });
  }
);
_.displayName = "TextareaInput";
export {
  _ as T,
  W as a,
  U as b,
  X as c,
  B as s
};
